import '../scss/style.scss'; //これを入れておかないとscssを読み込まない